import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import CNumberField from 'crqlar-react-common/dist/components/CNumberField';

interface NodeNumberFieldProps {
    label: string;
    value: number | undefined;
    onChange: (value: number | undefined) => void;
    min?: number;
    max?: number;
    helperText?: string;
    disabled?: boolean;
}

/** `CNumberField` reports `null` when empty; this passes `undefined`, so a cleared field falls back to the default. */
const NodeNumberField = ({label, value, onChange, min, max, helperText, disabled}: NodeNumberFieldProps) => (
    <Stack>
        <CNumberField
            label={label}
            value={value}
            onChange={next => onChange(next ?? undefined)}
            min={min}
            max={max}
            step={1}
            size={'small'}
            fullWidth
            disabled={disabled}
        />

        {!!helperText && (
            <FormHelperText sx={{mx: 1.75}}>{helperText}</FormHelperText>
        )}
    </Stack>
);

export default NodeNumberField;
